export function initialize() {
    $('[data-filter="area"]').each(function() {
        var area = $(this);
        var filter = area.find('[data-filter="form"]');
        var items = area.find('[data-filter="items"]')[0];

        var links = filter.find('a');
        var input = filter.find('input');

        var activeLink = area.find('a.active');

        if (activeLink) {
            var id = activeLink.attr('id');

            if (id === 'all') {
                $('[data-filter-group]').show();
                sort(items, 'default');
            } else {
                $('[data-filter-group]').hide();
                $('[data-filter-group*="' + id + '"]').show();
                sort(items, 'group'+id);
            }
        }

        links.on('click', function(e) {
            e.preventDefault();

            input.val('');

            var link = $(this);
            var id = link.attr('id');

            links.removeClass('active');
            link.addClass('active');

            if (id === 'all') {
                $('[data-filter-group]').show();
                sort(items, 'default');
            } else {
                $('[data-filter-group]').hide();
                $('[data-filter-group*="' + id + '"]').show();
                sort(items, 'group'+id);
            }
        });

        input.on('keyup', function() {
            links.removeClass('active');

            var input = $(this);
            var value = input.val().toLowerCase();

            if(value.length < 1) {
                $('[data-filter-name]').show();
            } else {
                $('[data-filter-name]').hide();
                $('[data-filter-name*="' + value + '"]').show();
            }
        });
    });
}

function sort(items, groupKey)
{
    let elements = items.childNodes;
    let sortMe = [];

    for (let i=0; i<elements.length; i++) {
        let element = elements[i];
        if(element.tagName && element.tagName.toUpperCase() === 'DIV') {
            let sortSett = element.getAttribute('data-filter-group-sort') || '{"default": 999999999999}'
            let sorts = JSON.parse(sortSett);
            let activeSort = (1 * (sorts.hasOwnProperty(groupKey) ? sorts[groupKey] : sorts.default));

            sortMe.push([ activeSort , element ]);
        }
    }

    sortMe.sort(function(x, y) {
        return x[0] - y[0];
    });

    for (let i=0; i<sortMe.length; i++) {
        items.appendChild(sortMe[i][1]);
    }
}

export default {};
